import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import metadata from './PropertyDetailsComponent.metadata.json5';
import styles from "../../../SpecialtyPersonalStyles.module.scss";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';
// import styles from '../BuildersRisk.module.scss';

function PropertyDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyDetailsComponent');
    const [isEditAddress, setIsEditAddress] = useState(false)
    const { showConfirm } = useModal();
    const modelVM = _.get(submissionVM, pathUpdated)
    const vacentOccCode = ['VacCom', 'VacDwe', 'VacCon']
    const rentedOccCode = ['RenCon', 'RenDwe']
    const seasonalOccCode = ['SeaDwe', 'SeaDwewitRen']
    const locRentedOccCode = ['RenDwe', 'RooHou', 'SeaDwewitRen', 'StuHou']

    modelVM.value.isValidationReq = true

    const [actAddress, setActAddress] = useState(null)

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const handleValueChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.${changedPath}`;

        if (value === 'new' && changedPath === 'actAdrsPublicID') {
            setIsEditAddress(true)
        }

        if (changedPath === "occFie") {
            const istheloccurrenFieValue = !_.isUndefined(_.get(modelVM, 'occFie.value.code')) &&
                locRentedOccCode.includes(_.get(modelVM, 'occFie.value.code'))

            _.set(modelVM, 'istheloccurrenFie.value', istheloccurrenFieValue)
        }

        _.set(submissionVM, `${fullPath}`, value);

        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {
            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };

    const deletePropertyDetails = useCallback(() => {
        const infoListPath = 'lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.value';
        const info = modelVM.value;
        const infoList = _.get(submissionVM, infoListPath);

        showConfirm({
            title: messages.removeInfo,
            message: messages.removeInfoDesc,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.yes,
            cancelButtonText: messages.no
        }).then((results) => {
            if (results === 'cancel') {
                return _.noop();
            }

            const newinfoList = _.remove(infoList, (infoFromList) => _.isEqual(infoFromList, info));

            _.set(submissionVM, newinfoList, infoListPath);
            updateWizardData(submissionVM);

            return true;
        }, _.noop);
    }, [modelVM.value, submissionVM, showConfirm, updateWizardData]);



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        ifothpleexpFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'Other'
        },
        numofOccFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'RooHou' && _.get(modelVM, 'doetheownlivonpreFie.value') === true
        },
        istheloccurrenFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        renTypFie: {
            visible: !_.isUndefined(modelVM.istheloccurrenFie.value) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
                && modelVM.istheloccurrenFie.value
        },
        wilthelocberenwit3dayFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && rentedOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        datdwebecbecvacFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        curStaFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        curStaisOthpleexpFie: {
            visible: _.get(modelVM, 'curStaFie.value.code') === 'Other'
                && !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        typofStrFie: {
            visible: submissionVM.value.baseData.baseState_Ext !== 'QC' && submissionVM.value.baseData.baseState_Ext !== 'NB',
            required: submissionVM.value.baseData.baseState_Ext !== 'QC' && submissionVM.value.baseData.baseState_Ext !== 'NB'
        },
        istheproviefrotherroaFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        istheproonpavroaFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        havmeabeetaktomaitunoFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        istheprobeimaiinuswinFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        howlonhasroohoubeemonFie: {
            visible:!_.isUndefined(_.get(modelVM, 'occFie.value.code')) &&  _.get(modelVM, 'occFie.value.code') === 'RooHou'
        },
        doetheownlivonpreFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && _.get(modelVM, 'occFie.value.code') === 'RooHou'
        },
        ifyesdoeownlivinsesuiFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && _.get(modelVM, 'occFie.value.code') === 'RooHou'
                && _.get(modelVM, 'doetheownlivonpreFie.value') === true
        },
        istheproinabyroaorwinFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && seasonalOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        numofoccannoccbythresFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && seasonalOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        ifyespledesFie: {
            visible: !_.isUndefined(_.get(modelVM, 'wilthebeanyrenFie.value')) && _.get(modelVM, 'wilthebeanyrenFie.value')
        },
        renBudFie: {
            visible: !_.isUndefined(_.get(modelVM, 'wilthebeanyrenFie.value')) && _.get(modelVM, 'wilthebeanyrenFie.value'),
            defaultValue: 0
        },
        wilthebeanystrrenFie: {
            visible: !_.isUndefined(_.get(modelVM, 'wilthebeanyrenFie.value')) && _.get(modelVM, 'wilthebeanyrenFie.value'),
            defaultValue: false
        },
        ifyespledes2Fie: {
            visible: !_.isUndefined(_.get(modelVM, 'wilthebeanystrrenFie.value')) && _.get(modelVM, 'wilthebeanystrrenFie.value')
                && !_.isUndefined(_.get(modelVM, 'wilthebeanyrenFie.value')) && _.get(modelVM, 'wilthebeanyrenFie.value')
        },
        isthebuislafordemFie: {
            visible: !_.isUndefined(_.get(modelVM, 'wilthebeanyrenFie.value')) && _.get(modelVM, 'wilthebeanyrenFie.value')
        },
        maintenanceAndCaretakingTitle: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code'))
        },
        istheprocheeve72hoperFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code')),
            defaultValue: true
        },
        ifYesNamofperchedwhouFie: {
            visible: _.get(modelVM, 'istheprocheeve72hoperFie.value') === true
                && !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        whoisresforthecaraproFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        othFie: {
            visible: !_.isUndefined(_.get(modelVM, 'whoisresforthecaraproFie.value.code')) && _.get(modelVM, 'whoisresforthecaraproFie.value.code') === 'Other'
                && !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        carNamFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        carPhoNumFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        howoftistheprovisFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        oth2Fie: {
            visible: !_.isUndefined(_.get(modelVM, 'howoftistheprovisFie.value.code')) && _.get(modelVM, 'howoftistheprovisFie.value.code') === 'Other'
                && !_.isUndefined(_.get(modelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(modelVM, 'occFie.value.code'))
        },
        dweTypFie: {
            visible: false
        }

    };


    const resolvers = {
        resolveCallbackMap: {
            deletePropertyDetails,
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            AddressComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyDetailsComponent.propTypes = wizardProps;
export default withRouter(PropertyDetailsComponent);
